import { hasFeature } from '../../../../shared-components/contexts/InstitutionContext';
import { IStep } from '../Interfaces/IStep';

export function GetSteps() {
  let i = 0;
  let steps = [
    { key: 0, name: 'Welcome Screen', stepNumber: i++ },
    { key: 1, name: 'Notation Type Select', stepNumber: i++ },
  ] as IStep[];

  if (hasFeature('Alerts'))
    steps.push({ key: 2, name: 'Alerts', stepNumber: i++ });

  steps.push({ key: 3, name: 'Updates', stepNumber: i++ });

  if (hasFeature('Encouragements'))
    steps.push({ key: 4, name: 'Encouragements', stepNumber: i++ });

  steps.push({ key: 5, name: 'Save', stepNumber: i++ });

  return steps;
}
